import notification_module_default from "./notification.module.js";
import { Body1 } from "../typography/Body1.js";
import { Notification } from "@mantine/core";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import "@mantine/notifications/styles.css";

//#region src/components/notification/Notification.tsx
const Notification$1 = ({ color, icon, loading, onClose, withCloseButton = true, children, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	let body = children;
	if (typeof children === "string") body = /* @__PURE__ */ jsx(Body1, {
		color: "white",
		children
	});
	return /* @__PURE__ */ jsx(Notification, {
		"data-testid": testId,
		radius: "xxs",
		icon,
		loading,
		withCloseButton,
		onClose,
		closeButtonProps: { "aria-label": t("notification.hideNotification") },
		classNames: notification_module_default,
		__vars: {
			"--bkg-color": `var(--mantine-color-${color ?? "gray"}-9)`,
			"--hover-bkg-color": `var(--mantine-color-${color ?? "gray"}-7)`
		},
		children: body
	});
};

//#endregion
export { Notification$1 as Notification };